// extracted by mini-css-extract-plugin
export default {"customLoader":"styles_customLoader__CsJRc"};